import {Vec2} from "../core/Vec2.js";
import {SimulationEvent} from "../manager/SimulationManager.js";
import {Player} from "../player/Player.js";

/**
 * The abstract base class for all static and dynamic objects in the game world.
 */
abstract class GameObject {
  abstract position: Vec2;
  abstract scale: Vec2;
  abstract rotation: number;

  /**
   * Comparator function for sorting GameObjects deterministically, ensuring
   * consistent simulation results.
   */
  static Comparator(a: GameObject, b: GameObject): number {
    return (
      a.position.x - b.position.x ||
      a.position.y - b.position.y ||
      a.scale.x - b.scale.x ||
      a.scale.y - b.scale.y ||
      a.rotation - b.rotation
    );
  }

  /**
   * Processes the interaction between this GameObject and a player.
   * This method is responsible for detecting interactions (like collisions or proximity)
   * and returning a list of events describing what happened. It should NOT modify
   * the player's state directly.
   * @param player The player to process against.
   * @returns An array of SimulationEvents that occurred, or an empty array if none.
   */
  abstract process(player: Player): SimulationEvent[];
}

export default GameObject;
